import type { MensajeTranscripcion } from '@/lib/llamadas/presentacion';
import { Icono } from '../Layout/iconos';

// Conversación bot ↔ cliente en burbujas (prototipo iter5): bot a la
// izquierda con etiqueta "Asistente IA", cliente a la derecha.

export function Transcripcion({ mensajes }: { mensajes: MensajeTranscripcion[] }) {
  if (mensajes.length === 0) {
    return (
      <p className="px-1 py-4 text-[12.5px] text-[var(--text-dim)]">
        Sin transcripción disponible todavía.
      </p>
    );
  }

  return (
    <div className="space-y-2.5">
      {mensajes.map((m, i) =>
        m.rol === 'bot' ? (
          <div
            key={i}
            data-testid="msg-bot"
            className="max-w-[85%] rounded-[var(--radius-sm)] rounded-bl-[3px] border border-[var(--border-soft)] bg-[var(--surface-2)] px-3.5 py-2.5"
          >
            <div className="mb-1 flex items-center gap-1.5 text-[11px] font-semibold text-[var(--text-dim)]">
              <Icono nombre="sparkle" className="h-3 w-3 shrink-0" />
              Asistente IA
            </div>
            <div className="whitespace-pre-line text-[13px] text-[var(--text)]">{m.texto}</div>
          </div>
        ) : (
          <div
            key={i}
            data-testid="msg-cliente"
            className="ml-auto max-w-[85%] rounded-[var(--radius-sm)] rounded-br-[3px] bg-[var(--navy)] px-3.5 py-2.5 text-white"
          >
            <div className="mb-1 text-[11px] font-semibold text-white/70">Cliente</div>
            <div className="whitespace-pre-line text-[13px]">{m.texto}</div>
          </div>
        )
      )}
    </div>
  );
}
